import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateInvitationGroupsAndHearingType,
  setIsUpdateInvitationGroupMappingsPanelOpen,
  isUpdateInvitationGroupMappingsPanelOpenSelector,
} from '../../../../../../features/pageFeatures/invitationGroupAdministrationPageSlice';
import { mapInvitationGroupToSelectedItem } from '../../utility/mapEntities';

export const useUpdateInvitationGroupMappings = (
  selectedHearingTypeKey,
  invitationGroupsByHearingTypeId,
) => {
  const dispatch = useDispatch();
  const [selectedInvitationGroupIds, setSelectedInvitationGroupIds] = useState(
    [],
  );

  useEffect(() => {
    setSelectedInvitationGroupIds(
      invitationGroupsByHearingTypeId.map(mapInvitationGroupToSelectedItem),
    );
  }, [invitationGroupsByHearingTypeId]);

  const isPanelOpen = useSelector(
    isUpdateInvitationGroupMappingsPanelOpenSelector,
  );

  function onPanelClose() {
    setSelectedInvitationGroupIds([]);
    dispatch(setIsUpdateInvitationGroupMappingsPanelOpen(false));
  }

  function onConfirm() {
    dispatch(
      updateInvitationGroupsAndHearingType({
        selectedInvitationGroupIds: selectedInvitationGroupIds,
        selectedHearingTypeKey: selectedHearingTypeKey,
      }),
    );
  }

  return {
    isPanelOpen,
    onPanelClose,
    selectedInvitationGroupIds,
    setSelectedInvitationGroupIds,
    onConfirm,
  };
};
